export const isModalOpen = (isOpen) => ({ type: "IS_MODAL_OPEN", payload: isOpen });

export const setBodyOverflow = (overflow) => ({ type: "SET_BODY_OVERFLOW", payload: overflow });

export const setMobileMenuOpen = (isOpen) => ({ type: "SET_MOBILE_MENU_OPEN", payload: isOpen });

export const setActiveSection = (sectionId) => ({ type: "SET_ACTIVE_SECTION", payload: sectionId });

export const setPrefersReducedMotion = (prefersReducedMotion) => ({
  type: "SET_PREFERS_REDUCED_MOTION",
  payload: prefersReducedMotion,
});

export const setPageMetadata = (metadata) => ({ type: "SET_PAGE_METADATA", payload: metadata });

export const setPwaMode = (mode) => ({ type: "SET_PWA_MODE", payload: mode });
